module.exports = {
      id: "icon-bold-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-bold",
      toString: function () {
        return this.url;
      }
    }